/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type useFinancialServiceUpdateTriggerQueryVariables = {
    projectId: string;
};
export type useFinancialServiceUpdateTriggerQueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly project: {
            readonly id: string;
            readonly financialCalculationTrigger: {
                readonly timestamp: number | null;
                readonly duration: number | null;
            } | null;
        } | null;
    } | null;
};
export type useFinancialServiceUpdateTriggerQuery = {
    readonly response: useFinancialServiceUpdateTriggerQueryResponse;
    readonly variables: useFinancialServiceUpdateTriggerQueryVariables;
};



/*
query useFinancialServiceUpdateTriggerQuery(
  $projectId: ID!
) {
  viewer {
    actualPersonId
    component(name: "financial_calculation_trigger")
    project(internalId: $projectId) {
      id
      financialCalculationTrigger(allowLongerRuntime: true) {
        timestamp
        duration
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "ID!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "financial_calculation_trigger"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"financial_calculation_trigger\")"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "internalId",
      "variableName": "projectId"
    }
  ],
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "allowLongerRuntime",
          "value": true
        }
      ],
      "concreteType": "FinancialCalculationTrigger",
      "kind": "LinkedField",
      "name": "financialCalculationTrigger",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        }
      ],
      "storageKey": "financialCalculationTrigger(allowLongerRuntime:true)"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFinancialServiceUpdateTriggerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFinancialServiceUpdateTriggerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "useFinancialServiceUpdateTriggerQuery",
    "operationKind": "query",
    "text": "query useFinancialServiceUpdateTriggerQuery(\n  $projectId: ID!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"financial_calculation_trigger\")\n    project(internalId: $projectId) {\n      id\n      financialCalculationTrigger(allowLongerRuntime: true) {\n        timestamp\n        duration\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '49eeb4998a84590649c08a7dbd78e6a9';
export default node;
